import { FunctionComponent, useState } from "react";

import { faPen } from "@fortawesome/pro-solid-svg-icons";

import { IGlossaryFileSupportExtended } from "../../../../../../features/translation/TranslationHeader/GlossarySelection/GlossarySelection.types";
import { translationKeys } from "../../../../../../models/app-translation-keys";
import { ColumnActionIcon } from "../../../../../Shared/ColumnActionIcon/ColumnActionIcon";
import { ManageGlossaryDialog } from "../../ManageGlossaryDialog/ManageGlossaryDialog";

export interface IAddSecurityGroupButtonProps {
  onUpdatedGlossary(): void;
  glossary?: IGlossaryFileSupportExtended;
  hide?: boolean;
}

const EditSecurityGroupButton: FunctionComponent<IAddSecurityGroupButtonProps> = (
  props: IAddSecurityGroupButtonProps,
) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const handleCloseAddSecurityGroupDialog = (success?: boolean) => {
    setIsPopupVisible(false);

    if (success) {
      props.onUpdatedGlossary();
    }
  };

  return (
    <div>
      {isPopupVisible && (
        <ManageGlossaryDialog
          isVisible={isPopupVisible}
          onHide={handleCloseAddSecurityGroupDialog}
          glossary={props.glossary}
        />
      )}

      {!props.hide && (
        <ColumnActionIcon
          rowData={props.glossary}
          icon={faPen}
          executeAction={() => setIsPopupVisible(true)}
          tooltipTranslationKey={translationKeys.adminArea.glossary.actions.updateGlossary}
        />
      )}
    </div>
  );
};

export default EditSecurityGroupButton;
